import axiosInstance from "auth/FetchInterceptor";
import { 
  ADDON_SERVICES_API, AIRPORT_FEES_API, DISTANCE_RATE_API, HOLIDAY_SURCHARGE_API, 
  MINIMUM_PRICES_API, PRICING_CALCULATE_API, RADIUS_RATES_API, TIME_SURCHARGES_API, 
  TOLL_ROUTES_API, TRIP_TYPES_API, VAT_SETTING_API, ZONE_RATES_API 
} from "constants/ApiConstant";
const PricingService = {};

PricingService.getDistanceRates = function () {
  return axiosInstance.get(DISTANCE_RATE_API, null);
};

PricingService.updateDistanceRates = function (data) {
  return axiosInstance.put(DISTANCE_RATE_API, data);
};

PricingService.getTimeSurcharges = function (data) {
  return axiosInstance.get(TIME_SURCHARGES_API, data);
};

PricingService.updateTimeSurcharges = function (data) {
  return axiosInstance.put(TIME_SURCHARGES_API, data);
};

PricingService.getTripTypes = function (data) {
  return axiosInstance.get(TRIP_TYPES_API, data);
};

PricingService.updateTripTypes = function (data) {
  return axiosInstance.put(TRIP_TYPES_API, data);
};

PricingService.getAddonServices = function (data) {
  return axiosInstance.get(ADDON_SERVICES_API, data);
};

PricingService.createAddonServices = function (data) {
  return axiosInstance.post(ADDON_SERVICES_API, data);
};

PricingService.updateAddonServices = function (data) {
  return axiosInstance.put(ADDON_SERVICES_API, data);
};

PricingService.deleteAddonServices = function (id) {
  return axiosInstance.delete(`${ADDON_SERVICES_API}/${id}`, null);
};

PricingService.getAirportFees = function (data) {
  return axiosInstance.get(AIRPORT_FEES_API, data);
};

PricingService.createAirportFees = function (data) {
  return axiosInstance.post(AIRPORT_FEES_API, data);
};

PricingService.updateAirportFees = function (data) {
  return axiosInstance.put(AIRPORT_FEES_API, data);
};

PricingService.deleteAirportFees = function (id) {
  return axiosInstance.delete(`${AIRPORT_FEES_API}/${id}`, null);
};

PricingService.getHolidaySurcharge = function (data) {
  return axiosInstance.get(HOLIDAY_SURCHARGE_API, data);
};

PricingService.updateHolidaySurcharge = function (data) {
  return axiosInstance.put(HOLIDAY_SURCHARGE_API, data);
};

PricingService.getTollRoutes = function (data) {
  return axiosInstance.get(TOLL_ROUTES_API, data);
};

PricingService.createTollRoutes = function (data) {
  return axiosInstance.post(TOLL_ROUTES_API, data);
};

PricingService.updateTollRoutes = function (data) {
  return axiosInstance.put(TOLL_ROUTES_API, data);
};

PricingService.deleteTollRoutes = function (id) {
  return axiosInstance.delete(`${TOLL_ROUTES_API}/${id}`, null);
};

// GIÁ THEO KHU VỰC (LOGIC 02A)

PricingService.getZoneRates = function (params) {
  return axiosInstance.get(ZONE_RATES_API, { params });
};

PricingService.createZoneRate = function (data) {
  return axiosInstance.post(ZONE_RATES_API, data);
};

PricingService.updateZoneRate = function (data) {
  return axiosInstance.put(ZONE_RATES_API, data);
};

PricingService.bulkUpsertZoneRate = function (data) {
  return axiosInstance.put(`${ZONE_RATES_API}/bulk`, data);
};

PricingService.deleteZoneRate = function (id) {
  return axiosInstance.delete(`${ZONE_RATES_API}/${id}`, null);
};

// GIÁ THEO BÁN KÍNH (LOGIC 02B)

PricingService.getRadiusRates = function (params) {
  return axiosInstance.get(RADIUS_RATES_API, { params });
};

PricingService.createRadiusRate = function (data) {
  return axiosInstance.post(RADIUS_RATES_API, data);
};

PricingService.updateRadiusRate = function (data) {
  return axiosInstance.put(RADIUS_RATES_API, data);
};

PricingService.bulkUpsertRadiusRate = function (data) {
  return axiosInstance.put(`${RADIUS_RATES_API}/bulk`, data);
};

PricingService.deleteRadiusRate = function (id) {
  return axiosInstance.delete(`${RADIUS_RATES_API}/${id}`, null);
};

// GIÁ SÀN

PricingService.getMinimumPrices = function (params) {
  return axiosInstance.get(MINIMUM_PRICES_API, { params });
};

PricingService.upsertMinimumPrice = function (data) {
  return axiosInstance.put(MINIMUM_PRICES_API, data);
};

PricingService.deleteMinimumPrice = function (id) {
  return axiosInstance.delete(`${MINIMUM_PRICES_API}/${id}`, null);
};

PricingService.getVatSetting = function () {
  return axiosInstance.get(VAT_SETTING_API, null);
};

PricingService.updateVatSetting = function (data) {
  return axiosInstance.put(VAT_SETTING_API, data);
};

PricingService.calculatePrice = function (data) {
  return axiosInstance.post(PRICING_CALCULATE_API, data);
};

export default PricingService;